import { useCallback } from 'react'

import type { F0FormSubmitResult } from '@factorialco/f0-react'

import { track, trackingEvents } from 'modules/core/lib/Tracking'
import { handleResult } from 'modules/core/lib/handleMutation'

import { useCreateTag } from 'modules/ats/hooks/tags/useCreateTag'

interface Props {
  companyId: string
}

export const useCreateTagAction = ({ companyId }: Props) => {
  const { loading, create } = useCreateTag()

  const createTag = useCallback(
    async (name: string): Promise<F0FormSubmitResult> => {
      const result = await create({
        name,
        companyId,
      })

      let fieldErrors: Record<string, string> = {}
      const handled = handleResult(result, ({ messages, ...rest }) => {
        fieldErrors = messages ? { ...rest, name: messages } : rest
      })

      if (handled.success) {
        track(trackingEvents.ats.createTag, { source: 'TagManager' })
        return { success: true }
      }

      return { success: false, errors: fieldErrors }
    },
    [companyId, create]
  )

  return {
    createTag,
    loading,
  }
}
